import React from "react";
import Phone2 from "../assets/phone2x.png";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import icon1 from "../assets/business icons-exposure.png";
import icon2 from "../assets/business icons-boost-2.png";
import icon3 from "../assets/business icons-booking system.png";

const Section2 = ({ changeModal }) => {
  const [ref1, inView1] = useInView({ triggerOnce: true });
  const [ref2, inView2] = useInView({ triggerOnce: true });
  const [ref3, inView3] = useInView({ triggerOnce: true });

  return (
    <div className="section2" id="business">
      <motion.img
        ref={ref1}
        initial={{ opacity: 0, scale: 0.2 }}
        animate={inView1 ? { opacity: 1, scale: 1 } : {}}
        transition={{
          duration: 0.6,
          delay: 0.2,
          type: "smooth",
        }}
        alt="phone 1"
        src={Phone2}
        className="phone2"
      />
      <div className="section2-main">
        <div style={{ width: "50%" }}>
          <h1>Grow your business with us</h1>
          <h2> Do you run a wellness, beauty, or personal care business?</h2>
          <p>
            <strong>In wellness, beauty, or personal care? 🚀</strong>
            <br />
            Connect with a vibrant audience eager for your services. Expand your
            reach and attract highly interested prospects who are ready to
            engage!
          </p>
        </div>

        <div className="section2-items-div">
          <motion.div
            ref={ref1}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={inView1 ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="section2-item"
            // style={{ flex: 0.3, display: "flex", flexDirection: "row" }}
          >
            <img
              src={icon1}
              alt="Get Exposure"
              width={64}
              height={64}
              className="Section2Icons "
            />
            <div style={{ display: "initial" }}>
              <h2>Get exposure</h2>
              <p>
                Have your business discovered by valuable prospects organically,
                or advertise to increase reach/frequency.
              </p>
            </div>
          </motion.div>

          <motion.div
            ref={ref2}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={inView2 ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="section2-item"
          >
            <img
              src={icon2}
              alt="Book Your Business"
              width={64}
              height={64}
              className="Section2Icons Icon2"
            />
            <div style={{ display: "initial" }}>
              <h2>Boost your business</h2>
              <p>
                Track your business history and boost growth through valuable
                reports and insights. + Facilitate the management of your staff
                and teams.
              </p>
            </div>
          </motion.div>

          <motion.div
            ref={ref3}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={inView3 ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="section2-item"
          >
            <img
              src={icon3}
              alt="Use a booking System "
              width={64}
              height={64}
              className="Section2Icons"
            />
            <div style={{ display: "initial" }}>
              <h2>Use as a booking system</h2>
              <p>
                Benefit from TheBooker’s intuitive appointment making process to
                substitute traditional booking systems.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div
          whileHover={{ scale: 1.1 }}
          transition={{ type: "spring", stiffness: 500, damping: 30 }}
          onClick={() => {
            document.body.style.overflow = "hidden";
            changeModal({
              show: true,
              data: {
                fullname: "",
                businessname: "",
                location: "",
                website: "",
                countrycode: "+961",
                phone: "",
                businessemail: "",
              },
            });
          }}
          className="subscribe-btn"
          style={{
            backgroundColor: "white",
            color: "#008a80",
            margin: "auto",
            marginTop: 60,
          }}
        >
          <p style={{ color: "#008a80", margin: 0, fontFamily: "Hurme-Bold" }}>
            JOIN US NOW
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Section2;
